import { HStack, Radio } from '@chakra-ui/react'

export const HorizontalRadios = ({ options }: { options?: { value?: string, label?: string }[] }) => {

  return <HStack gap={5}>
    {options?.map((option) => (
      <Radio key={option.value} gap={3} value={option.value}>
        {option.label}
      </Radio>
    ))}
  </HStack>
}
